<div class="subtitle">
  <h1>Legenda do Planejamento Terapêutico</h1>
  <div class="status">
    @for (status of listStatusScheduling; track status) {
      <div class="status-content">
        <span class="status-subtitle" [style.background-color]="status.color" [style.border-color]="status.color"></span>
        <span>{{status.name}}</span>
      </div>
    }
  </div>
</div>